export enum PremiumPlanDevice {
  ONE_DEVICE = "ONE_DEVICE",
  ALL_DEVICES = "ALL_DEVICES",
}

export enum PremiumPlanPeriod {
  YEAR = "YEAR",
  MONTH = "MONTH",
  SIX_MONTHS = "SIX_MONTHS",
}

//#region Stripe's
export enum StripePlan {
  allPlatformsMonthly = "all_platforms_monthly_new_web", // All Platforms (Monthly)
  allPlatformsYearly = "all_platforms_yearly_new_web", // All Platforms (Yearly)
  onePlatformsYearly = "one_platform_yearly_new_web", // One platform (Yearly)
  // New / Onboarding Plans
  webMonthly2019 = "web_monthly_2019", // Monthly
  web6Month2019 = "web_6_month_2019", // 6 Months
  webYearly2019 = "web_yearly_2019", // Yearly
  YearlySevenDaysDiscount = "premium_yearly_7_days_trial_60",
  monthlyNoDiscount = "premium_monthly_8",
  sixMonthsNoDiscount = "premium_6_months_42",

  // WhatsApp plan
  whatsAppYearly36Trial = "whatsapp_yearly_36_trial",
}

export enum PremiumSubscriptionPaymentProvider {
  GIFT_FREE_PERIOD = "GIFT_FREE_PERIOD",
  PLAY = "Play",
  IOS = "iOS",
  OSX = "OSx",
  BRAINTREE = "Braintree",
  STRIPE = "Stripe",
  GALAXY_GIFTS = "GalaxyGifts",
  // spellchecker:disable-next-line
  TMOBILE_CZ = "TMobile_CZ",
  // spellchecker:disable-next-line
  KIIP_30_DAYS = "KIIP_30_DAYS",
  INVITATION = "Invitation",
  WHITELIST = "",
}

export enum PremiumSubscriptionPlanPeriod {
  MONTH = "Month",
  YEAR = "Year",
  SIX_MONTHS = "6_Month",
  WHITELIST = "",
}

//#endregion

//#region Mac App Store
export enum MacAppStorePlan {
  // Legacy plans
  /** @depreacted */
  SubscriptionAllPlatforms_200_30 = "com.anydo.monthSubscriptionAllPlatforms_mac",
  /** @depreacted */
  SubscriptionAllPlatforms_600_365 = "com.anydo.yearSubscriptionAllPlatforms_mac",
  /** @depreacted */
  SubscriptionOnePlatform_600_365 = "com.anydo.yearSubscriptionOnePlatform_mac",

  // New plans
  AnyDo_6Months = "com.anydo.mac_6months",
  AnyDo_Monthly = "com.anydo.mac_monthly",
  AnyDo_Yearly = "com.anydo.mac_yearly",

  // Family
  Family_Monthly = "com.anydo.family_monthly_plan_mac_2024_01",
  Family_Yearly = "com.anydo.family_yearly_plan_mac_2024_01",
}
//#endregion

//#region Events
export type PremiumPrivateEventT =
  | IPremiumEventSubscriptionDuplicated
  | IPremiumEventSubscriptionSucceeded
  | IPremiumEventSubscriptionCancelled
  | IPremiumEventSubscriptionFailed;

export enum PremiumEventType {
  DUPLICATE = "DUPLICATE",
  SUBSCRIPTION_SUCCEEDED = "SUBSCRIPTION_SUCCEEDED",
  SUBSCRIPTION_CANCELLED = "SUBSCRIPTION_CANCELLED",
  SUBSCRIPTION_FAILED = "SUBSCRIPTION_FAILED",
}

export interface IPremiumEventSubscriptionDuplicated {
  type: PremiumEventType.DUPLICATE;
}

export interface IPremiumEventSubscriptionSucceeded {
  type: PremiumEventType.SUBSCRIPTION_SUCCEEDED;
  transactionId?: string;
}

export interface IPremiumEventSubscriptionCancelled {
  type: PremiumEventType.SUBSCRIPTION_CANCELLED;
}

export interface IPremiumEventSubscriptionFailed {
  type: PremiumEventType.SUBSCRIPTION_FAILED;
  error: Error;
}
//#endregion
